import { useEffect, useState } from 'react';
import { JoveGridItem } from '@jove-frontend/mui';
import { BusinessCenterOutlined } from '@mui/icons-material';
import { Box, Grid, Typography } from '@mui/material';

interface PolicyCoverageListInfoItemViewProps {
  list: Array<{
    title: string;
    content: string;
  }>;
}
const PolicyCoverageListInfoItemView = (props: PolicyCoverageListInfoItemViewProps) => {
  const { list } = props;
  const [coverInfoList, setCoverInfoList] = useState([]);

  /**
   * effects
   */
  useEffect(() => {
    setCoverInfoList(list || []);
  }, [list]);

  return (
    <Grid container className="w-full" spacing={1}>
      {coverInfoList.map((item, index) => {
        return (
          <Grid item xs={6} key={index}>
            <JoveGridItem className="h-full">
              <Box className="bg-grey-5 flex h-full flex-row items-center space-x-1 rounded-lg px-[8px] py-[6px]">
                <BusinessCenterOutlined />
                <Box className="flex flex-1 flex-row items-center justify-between">
                  <Typography variant="subtitle2" className="font-medium">
                    {item.title}
                  </Typography>
                  <Typography variant="subtitle2" className="font-bold">
                    {item.content}
                  </Typography>
                </Box>
              </Box>
            </JoveGridItem>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default PolicyCoverageListInfoItemView;
